export default {"src":"/_next/static/media/starcheck.bbe392d3.svg","height":134,"width":160,"blurWidth":0,"blurHeight":0};